import React from "react";
import ZTypography from "@atoms/ZTypography";
import { EFontWeights } from "@atoms/ZTypography/interface";

const ZFormulaIfDocumentation = () => {
	return (
		<div className="function-description-documentation-content">
			<div className="function-description-documentation-content-section">
				<ZTypography.ZText
					className="block"
					weight={EFontWeights.SEMIBOLD}
					level={1}
					colorVariant={8}
				>
					About
				</ZTypography.ZText>
				<ZTypography.ZText className="block" level={0} colorVariant={8}>
					Setup a conditional expression
				</ZTypography.ZText>
			</div>
			<div className="function-description-documentation-content-section">
				<ZTypography.ZText
					className="block"
					weight={EFontWeights.SEMIBOLD}
					level={1}
					colorVariant={8}
				>
					Example
				</ZTypography.ZText>
				<ZTypography.ZText className="block" level={0} colorVariant={8}>
					<pre className="m-0 mt-1">
						{`if(10 > 2, 10, 5)`}
						<br />
						<b>Output:</b>&nbsp;10
					</pre>
				</ZTypography.ZText>
			</div>
			<div className="function-description-documentation-content-section">
				<div className="block">
					<ZTypography.ZText
						className="mr-2"
						weight={EFontWeights.SEMIBOLD}
						level={1}
						colorVariant={8}
					>
						condition
					</ZTypography.ZText>
					<ZTypography.ZText
						italic
						weight={EFontWeights.SEMIBOLD}
						level={1}
						colorVariant={8}
					>
						BOOLEAN - Required
					</ZTypography.ZText>
				</div>
				<ZTypography.ZText
					className="block"
					italic
					level={0}
					colorVariant={8}
				>
					The boolean statement that determines what the calculated
					value will be.
				</ZTypography.ZText>
			</div>
			<div className="function-description-documentation-content-section">
				<div className="block">
					<ZTypography.ZText
						className="mr-2"
						weight={EFontWeights.SEMIBOLD}
						level={1}
						colorVariant={8}
					>
						arg2
					</ZTypography.ZText>
					<ZTypography.ZText
						italic
						weight={EFontWeights.SEMIBOLD}
						level={1}
						colorVariant={8}
					>
						STRING, BOOLEAN, NUMBER - Required
					</ZTypography.ZText>
				</div>
				<ZTypography.ZText
					className="block"
					italic
					level={0}
					colorVariant={8}
				>
					A boolean, number, or string that will be the calculated
					value if the condition is met.
				</ZTypography.ZText>
			</div>
			<div className="function-description-documentation-content-section">
				<div className="block">
					<ZTypography.ZText
						className="mr-2"
						weight={EFontWeights.SEMIBOLD}
						level={1}
						colorVariant={8}
					>
						arg3
					</ZTypography.ZText>
					<ZTypography.ZText
						italic
						weight={EFontWeights.SEMIBOLD}
						level={1}
						colorVariant={8}
					>
						STRING, BOOLEAN, NUMBER - Required
					</ZTypography.ZText>
				</div>
				<ZTypography.ZText
					className="block"
					italic
					level={0}
					colorVariant={8}
				>
					The calculated value if the condition is not met. If
					included, it must be the same type as arg2. If not used, the
					value will be null when the condition is not met.
				</ZTypography.ZText>
			</div>
		</div>
	);
};

export default ZFormulaIfDocumentation;
